import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LayoutModule } from "@angular/cdk/layout";

import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import {
  MatFormFieldModule,
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
} from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSidenavModule } from "@angular/material/sidenav";
import * as Sentry from "@sentry/angular";
import firebase from "firebase/compat/app";
import { TourStepTemplateComponent, provideUiTour } from "ngx-ui-tour-md-menu";
import { TranslocoRootModule } from "./transloco-root.module";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LorenDashboardModule } from "./features/loren-dashboard/loren-dashboard.module";
import { environment } from "../environments/environment";
import { LorenNavModule } from "./shared/modules/loren-nav/loren-nav.module";
import { LorenHttpInterceptor } from "./shared/interceptors/loren-loader-interceptor/loren-http-interceptor.service";
import { LorenMatPaginatorIntlService } from "./shared/services/loren-mat-paginator-intl-service/loren-mat-paginator-intl.service";
import { ClientTimezoneInterceptor } from "./shared/interceptors/client-timezone-interceptor/client-timezone.interceptor";
import { ClientLanguageInterceptor } from "./shared/interceptors/client-language-interceptor/client-language.interceptor";
import { LorenGeneralErrorComponent } from "./shared/modules/loren-error/components/loren-general-error/loren-general-error.component";
import { LorenErrorNotFoundComponent } from "./shared/modules/loren-error/components/loren-error-not-found/loren-error-not-found.component";
import { LorenForbiddenComponent } from "./shared/modules/loren-error/components/loren-forbidden/loren-forbidden.component";
import { LorenServiceUnavailableComponent } from "./shared/modules/loren-error/components/loren-service-unavailable/loren-service-unavailable.component";
import { Router } from "@angular/router";
import { GestureHandling } from "leaflet-gesture-handling";
import L from "leaflet";

firebase.initializeApp(environment.firebase);
L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);


@NgModule({
  declarations: [AppComponent],
  exports: [],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    LayoutModule,
    TourStepTemplateComponent,
    TranslocoRootModule,
    MatBadgeModule,
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatToolbarModule,
    LorenDashboardModule,
    LorenNavModule,

    LorenGeneralErrorComponent,
    LorenErrorNotFoundComponent,
    LorenForbiddenComponent,
    LorenServiceUnavailableComponent,
  ],
  providers: [
    provideUiTour(),
    MatSnackBar,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
        // Needed for deps initialization
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: "dynamic", appearance: "outline" },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LorenHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClientTimezoneInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClientLanguageInterceptor,
      multi: true,
    },
    {
      provide: MatPaginatorIntl,
      useClass: LorenMatPaginatorIntlService,
    },
    provideHttpClient(withXhr(), withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppModule {}
